import { TENANTS_NAMES } from './host_config';
import SignUp from 'pages/SignUp';
import deepmerge from 'deepmerge';
import routes from '../utils/routes';
import { getTenantPreLoginConfig } from './teanantPreLoginConfig';
import { LandingRegisterPage } from 'pages/Landing/Landing';

const getDefaultNavigationConfig = () => {
  return {
    registrationPage: {
      SignUp: {
        path: `${routes.signup}/:userDataHash`,
        component: SignUp,
        isEnabled: true,
      },
    },
  };
};

const navigationConfigByTenant = {
  [TENANTS_NAMES.xpo]: {
    registrationPage: {
      SignUp: {
        path: routes.signup,
        component: LandingRegisterPage,
      },
    },
  },
  [TENANTS_NAMES.intraser]: {
    registrationPage: {
      SignUp: {
        isEnabled: false,
      },
    },
  },
};

const getNavigationConfig = (tenant) => {
  const defaulNavigationConfig = getDefaultNavigationConfig();
  return deepmerge(
    defaulNavigationConfig,
    navigationConfigByTenant[tenant] || {}
  );
};

const getCurrentTenantNavigationConfig = () => {
  const currentTenant = getTenantPreLoginConfig().tenant_name;
  return getNavigationConfig(currentTenant);
};

export { getNavigationConfig, getCurrentTenantNavigationConfig };
